import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FiCheckCircle, FiAlertCircle, FiInfo, FiAlertTriangle } from 'react-icons/fi';

const FeedbackModal = ({ show, onHide, type, title, message }) => {
    // Configuração visual baseada no tipo de alerta
    // Cores baseadas no Design System (Core Memory)
    const config = {
        success: {
            variant: 'success',
            icon: <FiCheckCircle size={64} className="text-success mb-3" />,
            color: '#69F0AE', // Success
            defaultTitle: 'Sucesso'
        },
        error: {
            variant: 'danger',
            icon: <FiAlertCircle size={64} className="text-danger mb-3" />,
            color: '#FF5252', // Error (Standard UI Red)
            defaultTitle: 'Erro'
        },
        danger: { // Alias para error
            variant: 'danger',
            icon: <FiAlertCircle size={64} className="text-danger mb-3" />,
            color: '#FF5252',
            defaultTitle: 'Erro'
        },
        warning: {
            variant: 'warning',
            icon: <FiAlertTriangle size={64} className="text-warning mb-3" />,
            color: '#FFD54F', // Accent
            defaultTitle: 'Atenção'
        },
        info: {
            variant: 'info',
            icon: <FiInfo size={64} className="text-info mb-3" />,
            color: '#00BFA5', // Primary
            defaultTitle: 'Informação'
        }
    };

    const currentConfig = config[type] || config.info;
    const displayTitle = title || currentConfig.defaultTitle;

    return (
        <Modal 
            show={show} 
            onHide={onHide} 
            centered 
            backdropClassName="modal-backdrop-blur"
            className="feedback-modal"
            aria-labelledby="feedback-modal-title"
            aria-describedby="feedback-modal-desc"
        >
            <div 
                className="modal-header-strip" 
                style={{ backgroundColor: currentConfig.color, height: '6px', width: '100%' }} 
            />
            <Modal.Body className="text-center p-4 pt-5">
                <div className="mb-4 fade-in-up icon-wrapper">
                    {currentConfig.icon}
                </div>
                
                <h4 id="feedback-modal-title" className="fw-bold mb-3 text-dark font-nunito">
                    {displayTitle}
                </h4>
                
                <p id="feedback-modal-desc" className="text-muted mb-4 font-inter fs-6">
                    {message}
                </p>
                
                <Button 
                    variant={currentConfig.variant} 
                    onClick={onHide}
                    className="w-100 rounded-pill fw-bold py-2 shadow-sm text-white"
                    style={{ 
                        backgroundColor: currentConfig.variant === 'warning' ? '#FFC107' : currentConfig.color,
                        borderColor: currentConfig.variant === 'warning' ? '#FFC107' : currentConfig.color
                    }}
                >
                    Fechar
                </Button>
            </Modal.Body>
        </Modal>
    );
};

export default FeedbackModal;
